import ShadowView from "./ShadowView"

export default {
    ShadowView
}